import React, { useEffect } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import ButtonWrapper from "../../../components/Button";
import InputWrapper from "../../../layout/inputWrapper";
import { Col, Container, Row } from "react-bootstrap";

const SubStep2 = ({ formData, handleSubTabChange, isEmployee }) => {
  const { t } = useTranslation();
  const defaultValues = {
    ...formData,
  };
  const { handleSubmit, watch, setValue, control } = useForm({ defaultValues });

  const watchRegistrationType = formData?.registrationType;
  const watchlandUseType = watch("plotInfo.zoneType") === "Residential Use Zone";
  const watchTotalBuildUpArea = watch("totalBuildUpArea");
  useEffect(() => {
    setValue("plotInfo.plotArea", formData?.plotArea);
    setValue("plotInfo.builtupArea", formData?.totalBuildUpArea);
  }, []);
  const onSubmit = (data) => {
    handleSubTabChange(2, data);
  };
  return (
    <section className="groupContainer2">
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="formContainer">
          <div className="formHeaderContainer">
            <h2 className="formHeading">{t("Plot Details")}</h2>
          </div>
          <Container fluid className="formInputContainer common-app-form">
            <Row>
              <Col>
                <InputWrapper
                  label={t("Plot Area (sq.mtr)")}
                  control={control}
                  placeholder={t("Enter Plot Area")}
                  name="descriptionOfLand.landArea"
                  mandatory
                  maxLength={15}
                  defaultValue={formData?.descriptionOfLand?.landArea}
                  type="textInput"
                  disabled={formData?.plotArea || isEmployee}
                  validation={{
                    required: {
                      value: true,
                      message: "This field is required",
                    },
                  }}
                />
              </Col>

              {formData?.edcrNumber ? (
                <Col>
                  <InputWrapper
                    label={t("Plot Area as per drawing (sq.mtr)")}
                    control={control}
                    placeholder={t("Enter Plot Area as per drawing")}
                    name="plotInfo.plotArea"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.plotArea || formData?.plotInfo?.plotArea}
                    type="textInput"
                    disabled={formData?.plotArea || isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              ) : (
                <Col>
                  {" "}
                  <InputWrapper
                    label={t("Total Proposed Built up Area (sq.mtr)")}
                    control={control}
                    placeholder={t("Enter Total Proposed Built up Area")}
                    name="totalBuildUpArea"
                    mandatory
                    maxLength={15}
                    defaultValue={formData?.totalBuildUpArea || formData?.plotInfo?.builtupArea}
                    type="textInput"
                    // maxValue={Number(formData?.descriptionOfLand?.landArea) * 2}
                    disabled={isEmployee}
                    validation={{
                      required: {
                        value: true,
                        message: "This field is required",
                      },
                    }}
                  />
                </Col>
              )}
            </Row>
            {/* <Row>
                            <Col>
                                <InputWrapper
                                    label={t("Estimated Cost (INR)")}
                                    control={control}
                                    placeholder={t("Enter Estimated Cost")}
                                    name="plotInfo.estimatedCost"
                                    mandatory
                                    maxLength={15}
                                    defaultValue={formData?.plotInfo?.estimatedCost}
                                    disabled={isEmployee}
                                    type="textInput"
                                    validation={{
                                        required: {
                                          value: true,
                                          message: "This field is required",
                                        },
                                    }}
                                />
                            </Col>
                            <Col></Col>
                        </Row> */}
          </Container>
        </div>
        {!isEmployee && (
          <div className="footerContainer">
            <div className="buttonWrapper">
              <ButtonWrapper
                variant="contained"
                color="error"
                size="medium"
                label="Prev"
                sx={{ backgroundColor: "#CCC" }}
                onClick={() => handleSubTabChange(0)}
              />
              <ButtonWrapper variant="contained" color="success" size="medium" label="Save" type="submit" sx={{ backgroundColor: "#157CB3" }} />
            </div>
          </div>
        )}
      </form>
    </section>
  );
};

export default SubStep2;
